import { useEffect, useState } from "react";

/**
 * Re-render trigger for components that resolve CSS variables into concrete
 * values (e.g. Chart.js canvases). Bumps whenever the root [data-theme]
 * attribute changes so token-derived colors are re-read.
 */
export const useThemeVersion = (): number => {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const observer = new MutationObserver(() => setVersion((v) => v + 1));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  return version;
};

export default useThemeVersion;
